import React, { createContext, useContext, useState } from "react";

// Contexto para el estado global de onboardingSteps
export const OnboardingContext = createContext({
  onboardingSteps: [],
  setOnboardingSteps: () => {},
  shouldOpenOnboarding: false,
  setShouldOpenOnboarding: () => {},
  checkAndTriggerOnboarding: () => {},
});

export const useOnboarding = () => useContext(OnboardingContext);

// Proveedor del contexto
export const OnboardingProvider = ({ children, initialSteps = [] }) => {
  const [onboardingSteps, setOnboardingSteps] = useState(initialSteps);
  const [shouldOpenOnboarding, setShouldOpenOnboarding] = useState(false);

  React.useEffect(() => {
    setOnboardingSteps(initialSteps);
  }, [initialSteps]);

  // Función para verificar si un paso específico debe activar el onboarding
  const checkAndTriggerOnboarding = (step) => {
    const stepExists = onboardingSteps.includes(step);
    if (!stepExists) {
      setShouldOpenOnboarding(true);
      return true; // Debe abrir el onboarding
    }
    return false; // No debe abrir el onboarding
  };

  return (
    <OnboardingContext.Provider
      value={{
        onboardingSteps,
        setOnboardingSteps,
        shouldOpenOnboarding,
        setShouldOpenOnboarding,
        checkAndTriggerOnboarding,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};
